import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const CurrencyContext = createContext(null);
const API_URL = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_RATE = 4.6;

export const CurrencyProvider = ({ children }) => {
  const [rate, setRate] = useState(DEFAULT_RATE);

  const fetchRate = useCallback(async () => {
    try {
      const res = await axios.get(`${API_URL}/api/currency/rate`);
      if (res.data?.rate) {
        setRate(res.data.rate);
      }
    } catch {
      // Keep default rate
    }
  }, []);

  useEffect(() => {
    fetchRate();
    const interval = setInterval(fetchRate, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [fetchRate]);

  return (
    <CurrencyContext.Provider value={{ rate, setRate }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => {
  const ctx = useContext(CurrencyContext);
  if (!ctx) return { rate: DEFAULT_RATE };
  return ctx;
};
